import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import { firebaseConfig } from "./firebase-config";
import { unMachine } from "./filters";
import VueAnnouncer from "vue-announcer";
import "firebase/firestore";
import { mapMutations } from "vuex";

Vue.config.productionTip = false;

// Filters.
Vue.filter("unMachine", unMachine);

// Vue announcer.
Vue.use(VueAnnouncer, {}, router);

// Main vue instance.
new Vue({
  router,
  store,

  methods: {
    ...mapMutations(["setDB", "setAnalytics"]),
  },

  created() {
    firebase.initializeApp(firebaseConfig);
    this.setAnalytics(firebase.analytics());

    firebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        this.$router.push("/auth");
      }
    });

    // Set database object.
    this.setDB(firebase.firestore());

    // Enable persistence.
    firebase.firestore().enablePersistence();
  },

  render: (h) => h(App),
}).$mount("#app");
